<template>
    <div>
        <div class="px-3 py-3">
            <v-toolbar flat color="white">
                <v-toolbar-title>Songs</v-toolbar-title>
                <v-divider class="mx-4" inset vertica></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark
                       class="mb-2" @click="newItem()">New Song
                </v-btn>
            </v-toolbar>

            <v-text-field label="Search Songs" v-on:keyup.enter="searchSong()"
                          v-model="searchSongText"></v-text-field>

            <v-data-table :headers="songHeaders"
                          :items="allList"
                          :loading="isLoading"
                          show-select
                          :single-select="true"
                          hide-default-footer>
                <template v-slot:item.actions="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                    >
                        mdi-pencil
                    </v-icon>
                    <v-icon
                            small
                            @click="deleteItem(item)"
                    >
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
            <pagination :page="page" :total-page="totalPage"
                        @paginate="paginate($event)"></pagination>

            <v-dialog v-model="addEditDialog" persistent hide-overlay width="80%">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-toolbar-title>Title</v-toolbar-title>
                                <v-text-field v-model="songTitle"
                                              label="Title"
                                              :error="hasTitleError"
                                              :error-messages="songTitleError"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-toolbar-title>Length</v-toolbar-title>
                                <v-text-field v-model="songLength"
                                              :readonly="true"
                                              label="Length(seconds)"
                                              :error="hasLengthError"
                                              :error-messages="lengthError"
                                ></v-text-field>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-toolbar-title>File</v-toolbar-title>
                                <v-autocomplete
                                        v-model="selectedFile"
                                        :items="files"
                                        :loading="searchFileLoading"
                                        :search-input.sync="searchFileText"
                                        chips
                                        clearable
                                        hide-details
                                        hide-selected
                                        item-text="name"
                                        label="Search File"
                                        return-object
                                        solo
                                        v-on:keypress.enter="searchFiles()"
                                        :error="hasFileError"
                                        :error-messages="fileError"
                                >
                                    <template v-slot:selection="{ attr, on, item, selected }">
                                        <v-chip
                                                v-bind="attr"
                                                :input-value="selected"
                                                color="blue-grey"
                                                class="white--text"
                                                v-on="on">
                                            <span v-text="item.name"></span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-toolbar-title>Albums</v-toolbar-title>
                                <v-autocomplete
                                        v-model="selectedAlbum"
                                        :items="albums"
                                        item-text="title"
                                        :loading="searchAlbumLoading"
                                        hide-no-data
                                        hide-selected
                                        label="Search Album"
                                        v-on:keypress.enter="searchAllAlbums()"
                                        :search-input.sync="searchAlbumText"
                                        return-object
                                        chips
                                        clearable
                                        hide-details
                                        solo>
                                    <template v-slot:selection="{ attr, on, item, selected }">
                                        <v-chip
                                                v-bind="attr"
                                                :input-value="selected"
                                                color="blue-grey"
                                                class="white--text"
                                                v-on="on">
                                            <span v-text="item.title"></span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>

                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-toolbar-title>Artist</v-toolbar-title>
                                <v-autocomplete
                                        v-model="selectedArtist"
                                        :items="artists"
                                        item-text="name"
                                        :loading="searchArtistLoading"
                                        hide-no-data
                                        hide-selected
                                        label="Search Artist"
                                        v-on:keypress.enter="searchAllArtists"
                                        :search-input.sync="searchArtistText"
                                        return-object
                                        chips
                                        clearable
                                        hide-details
                                        solo
                                >
                                    <template v-slot:selection="{ attr, on, item, selected }">
                                        <v-chip
                                                v-bind="attr"
                                                :input-value="selected"
                                                color="blue-grey"
                                                class="white--text"
                                                v-on="on">
                                            <span v-text="item.name"></span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-toolbar-title>Media</v-toolbar-title>
                                <v-autocomplete v-model="selectedMedia"
                                                :items="medias"
                                                item-text="title"
                                                :loading="searchMediaLoading"
                                                hide-no-data
                                                hide-selected
                                                label="Search Media"
                                                v-on:keypress.enter="searchAllMedias"
                                                :search-input.sync="searchMediaText"
                                                return-object
                                                chips
                                                clearable
                                                hide-details
                                                solo
                                >
                                    <template v-slot:selection="{ attr, on, item, selected }">
                                        <v-chip
                                                v-bind="attr"
                                                :input-value="selected"
                                                color="blue-grey"
                                                class="white--text"
                                                v-on="on">
                                            <span v-text="item.title"></span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6">

                                <v-toolbar-title>Song Type</v-toolbar-title>
                                <v-autocomplete
                                        v-model="selectedSongType"
                                        :items="songTypes"
                                        item-text="name"
                                        :loading="searchSongTypeLoading"
                                        hide-no-data
                                        hide-selected
                                        label="Search Song Type"
                                        v-on:keypress.enter="searchAllSongType"
                                        :search-input.sync="searchSongTypeText"
                                        return-object
                                        chips
                                        clearable
                                        hide-details
                                        solo
                                >
                                    <template v-slot:selection="{ attr, on, item, selected }">
                                        <v-chip
                                                v-bind="attr"
                                                :input-value="selected"
                                                color="blue-grey"
                                                class="white--text"
                                                v-on="on">
                                            <span v-text="item.name"></span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-toolbar-title>Cd Links</v-toolbar-title>
                                <v-autocomplete
                                        v-model="selectedCdLinks"
                                        :items="cdLinks"
                                        item-text="name"
                                        :loading="searchCdLinksLoading"
                                        hide-no-data
                                        hide-selected
                                        label="Search All Cd Links"
                                        v-on:keypress.enter="searchAllCdLinks"
                                        :search-input.sync="searchCdLinksText"
                                        return-object
                                        chips
                                        clearable
                                        hide-details
                                        solo
                                        multiple
                                >
                                    <template v-slot:selection="{ attr, on, item, selected }">
                                        <v-chip
                                                v-bind="attr"
                                                :input-value="selected"
                                                color="blue-grey"
                                                class="white--text"
                                                v-on="on">
                                            <span v-text="item.name"></span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-toolbar-title>Thumbnail</v-toolbar-title>
                                <v-autocomplete
                                        v-model="selectedThumbnail"
                                        :items="thumbnails"
                                        item-text="name"
                                        :loading="searchThumbnailLoading"
                                        hide-no-data
                                        hide-selected
                                        label="Search Cover Image"
                                        v-on:keypress.enter="searchAllThumbnail"
                                        :search-input.sync="searchThumbnailText"
                                        return-object
                                        chips
                                        clearable
                                        hide-details
                                        solo
                                >
                                    <template v-slot:selection="{ attr, on, item, selected }">
                                        <v-chip
                                                v-bind="attr"
                                                :input-value="selected"
                                                color="blue-grey"
                                                class="white--text"
                                                v-on="on">
                                            <span v-text="item.name"></span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>


        </div>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination';
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import {
        AlbumService,
        ArtistService,
        CdLinkService,
        FileService,
        MediaService,
        SongTypeService, ThumbnailService
    } from "../../services";

    export default {
        name: "SongPanel",
        components: {
            Pagination
        },
        created() {
            this.initialize();
        },
        data() {
            return {
                loading: false,
                songHeaders: [{
                    text: 'Title',
                    align: 'start',
                    sortable: true,
                    value: 'title',
                },
                    {text: 'Actions', value: 'actions', sortable: false},
                ],

                songTitle: '',
                songLength: 0,

                //selected
                selectedSong: null,
                selectedMedia: null,
                selectedFile: null,
                selectedArtist: null,
                selectedAlbum: null,
                selectedSongType: null,
                selectedCdLinks: [],
                selectedThumbnail: null,

                //loading
                searchFileLoading: false,
                searchArtistLoading: false,
                searchMediaLoading: false,
                searchAlbumLoading: false,
                searchSongTypeLoading: false,
                searchCdLinksLoading: false,
                searchThumbnailLoading: false,

                //search
                searchSongText: '',

                searchArtistText: '',
                searchFileText: '',
                searchMediaText: '',
                searchAlbumText: '',
                searchSongTypeText: '',
                searchCdLinksText: '',
                searchThumbnailText: '',

                //data
                files: [],
                artists: [],
                albums: [],
                medias: [],
                songTypes: [],
                cdLinks: [],
                thumbnails: [],


                //errors
                songTitleError: '',
                fileError: '',
                lengthError: '',

                artistError: '',
                mediaError: '',
                albumError: '',
                songTypeError: '',

                hasTitleError: false,
                hasFileError: false,
                hasLengthError: false
            }
        },
        watch: {
            addEditDialog(nVal){
                nVal ||this.close();
            },
            selectedFile(newVal) {
                if (newVal == null) {
                    this.songLength = 0;
                } else {
                    this.songLength = newVal.length
                }
            }
        },
        computed: {
            page() {
                return this.getPagination().page;
            },
            perPage() {
                return this.getPagination().perPage;
            },
            totalPage() {
                return this.getPagination().totalPage;
            },
            allList() {
                return this.getAll();
            },
            isLoading() {
                return this.getLoading()
            },
            addEditDialog: {
                get() {
                    return this.showAddEditDialog();
                },
                set(value) {
                    this.setShowAddEditDialog(value);
                }
            }
        },
        methods: {
            ...mapMutations({
                setShowAddEditDialog: 'song/SHOW_ADD_EDIT_DIALOG'
            }),
            ...mapGetters({
                getPagination: 'song/getPagination',
                getLoading: 'song/getLoading',
                getAll: 'song/getAll',
                showAddEditDialog: 'song/showAddEditDialog'
            }),
            ...mapActions({
                requestAll: 'song/requestAll',
                setPage: 'song/setPage',
                setSearch: 'song/setSearch',
                setSave: 'song/setSave',
                setEdit: 'song/setEdit'
            }),
            initialize() {
                this.requestAll();
            },
            newItem() {
                this.assignDefault();
                this.setShowAddEditDialog(true);
            },
            editItem(item) {
                this.editedIndex = this.allList.indexOf(item);

                this.selectedSong = item;
                this.songTitle = item.title;
                this.songLength = item.length;

                this.files = [item.songFile];
                this.selectedFile = item.songFile;

                if (item.media != null) {
                    this.medias = [item.media];
                    this.selectedMedia = item.media;
                }

                if (item.artist != null) {
                    this.artists = [item.artist];
                    this.selectedArtist = item.artist;
                }
                if (item.album != null) {
                    this.albums = [item.album];
                    this.selectedAlbum = item.album;
                }

                if (item.songType != null) {
                    this.songTypes = [item.songType];
                    this.selectedSongType = item.songType;
                }


                if (item.cdLinks != null) {
                    this.cdLinks = item.cdLinks;
                    this.selectedCdLinks = item.cdLinks;
                }

                if (item.thumbnail != null) {
                    this.thumbnails = [item.thumbnail];
                    this.selectedThumbnail = item.thumbnail;
                }
                this.setShowAddEditDialog(true)
            },
            searchSong() {
                this.setSearch(this.searchSongText);
            },


            searchFiles() {
                if (this.searchFileLoading) return;

                this.searchFileLoading = true;

                // Lazily load input items
                FileService.getAll(null, this.searchFileText)
                    .then(res => {
                        console.log(res.results);
                        this.files.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.searchFileLoading = false))
            },

            searchAllAlbums() {
                if (this.searchAlbumLoading) return;

                this.searchAlbumLoading = true;

                AlbumService.getAll(null, this.searchAlbumText)
                    .then(res => {
                        this.albums.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.searchAlbumLoading = false))

            },

            searchAllArtists() {
                if (this.searchArtistLoading) return;

                this.searchArtistLoading = true;

                ArtistService.getAll(null, this.searchAlbumText)
                    .then(res => {
                        this.artists.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.searchArtistLoading = false))
            },

            searchAllMedias() {
                if (this.searchMediaLoading) return;

                this.searchMediaLoading = true;

                this.medias = [];
                MediaService.getAll(null, this.searchMediaText)
                    .then(res => {
                        this.medias.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.searchMediaLoading = false))
            },
            searchAllSongType() {
                if (this.searchSongTypeLoading) return;

                this.searchSongTypeLoading = true;

                this.songTypes = [];
                SongTypeService.getAll(null, this.searchSongTypeText)
                    .then(res => {
                        this.songTypes.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.searchSongTypeLoading = false))
            },
            searchAllCdLinks() {
                if (this.searchCdLinksLoading) return;

                this.searchCdLinksLoading = true;

                this.cdLinks = [];
                CdLinkService.getAll(null, this.searchCdLinksText)
                    .then(res => {
                        this.cdLinks.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.searchCdLinksLoading = false))
            },
            searchAllThumbnail() {
                if (this.searchThumbnailLoading) return;

                this.searchThumbnailLoading = true;

                this.thumbnails = [];
                ThumbnailService.getAll(null, this.searchThumbnailText)
                    .then(res => {
                        this.thumbnails.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.searchThumbnailLoading = false))
            },


            validate() {
                let valid = true;
                if (this.isTextEmpty(this.songTitle)) {
                    this.songTitleError = "Title can't be empty";
                    valid = false;
                }

                if (this.songLength === 0) {
                    this.lengthError = "Invalid Length";
                    valid = false;
                }

                if (!this.selectedFile) {
                    this.fileError = "Invalid File";
                    valid = false;
                }

                return valid;
            },


            isTextEmpty(text) {
                return text === undefined || text.trim().length === 0
            },

            paginate(page) {
                this.setPage(page);
            },
            save() {
                if (!this.validate()) return;

                if (this.editedIndex === -1) {
                    this.setSave({
                        title: this.songTitle
                        , length: this.songLength
                        , songFile: this.selectedFile
                        , artist: this.selectedArtist
                        , album: this.selectedAlbum
                        , media: this.selectedMedia
                        , thumbnail: this.selectedThumbnail
                        , cdLinks: this.selectedCdLinks
                        , songType: this.selectedSongType
                    })
                } else {
                    this.setEdit({
                        itemToEdit: {
                            parseItem: this.selectedSong.parseItem
                            , title: this.songTitle
                            , length: this.songLength
                            , songFile: this.selectedFile
                            , artist: this.selectedArtist
                            , album: this.selectedAlbum
                            , media: this.selectedMedia
                            , thumbnail: this.selectedThumbnail
                            , cdLinks: this.selectedCdLinks
                            , songType: this.selectedSongType
                        },
                        itemIndex: this.editedIndex
                    })
                }
            },
            close() {
                this.assignDefault();
                this.setShowAddEditDialog(false);
            },
            assignDefault(){
                this.editedIndex = -1;
                this.songTitle = '';
                this.selectedMedia = null;
                this.selectedFile = null;
                this.selectedArtist = null;
                this.selectedAlbum = null;
                this.selectedSongType = null;
                this.selectedCdLinks = [];
                this.selectedThumbnail = null;
            }
        }
    }
</script>

<style scoped>

</style>